import React, { Component } from 'react';

class MapLink extends Component {

  constructor(props) {
    super(props);
    this.analytics = this.props.analytics;
  }

  handleClick = (event) => {
    window.location.assign(`/map/${this.props.slug}`);
  }


  render() {
    let href = `/map/${this.props.slug}`;
    return (
      <li onClick={this.handleClick}
        className={this.props.className}>
        <a onClick={this.handlClick} href={href}>
          {this.props.children}
        </a>
      </li>
    );
  }

}

export default MapLink;



// WEBPACK FOOTER //
// ./src/components/GlobalHeader/MapLink.js